var map = {
	"./1fc_heidenheim_1846.png": 2424,
	"./1fc_union_berlin.png": 2364,
	"./1fsv_mainz_05.png": 653,
	"./bayer_04_leverkusen.png": 258,
	"./bayern_munich.png": 4879,
	"./borussia_dortmund.png": 9275,
	"./borussia_monchengladbach.png": 2354,
	"./eintracht_frankfurt.png": 4865,
	"./fc_augsburg.png": 2833,
	"./fc_st_pauli.png": 8640,
	"./holstein_kiel.png": 7679,
	"./rb_leipzig.png": 9890,
	"./sc_freiburg.png": 654,
	"./sv_werder_bremen.png": 9272,
	"./tsg_1899_hoffenheim.png": 9993,
	"./vfb_stuttgart.png": 9704,
	"./vfl_bochum.png": 90,
	"./vfl_wolfsburg.png": 2419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9430;